/* AI相談 畳み込み + グリッド→診断の引き継ぎ
   (game-search-section の consult_collapsed=true 時のみ読込)
   - ロード時は表示状態で既存JSを初期化させ、初期化後に #WzApp を隠す(後付けhidden方式)
   - 引き継ぎ: グリッドv3の選択を el.click() シミュレーションで診断側へ同期
     (現在状態(onクラス)と目標が違うタイルだけclick = 冪等。診断ロジックは直接触らない)
   - 同期はグリッド→診断の一方向のみ */
(function(){
  var scope = document.querySelector('.tg-gss-scope');
  if (!scope) return;
  var app = document.getElementById('WzApp');
  var launcher = document.getElementById('tgv3Launcher');
  var openBtn = document.getElementById('tgConsultOpen');
  var pickedWrap = document.getElementById('tgv3LauncherPicked');
  var pickedList = document.getElementById('tgv3PickedList');
  if (!app || !launcher || !openBtn) return;

  var isOpen = false;
  var userExpandedTitles = false;   /* 「変更する」を押したら以降は畳み直さない */

  function getPicked(){
    if (typeof window.tgv3GetPicked === 'function') return window.tgv3GetPicked();
    return { keys: [], labels: [] };
  }

  /* 引き継ぎ同期: 目標と現在(onクラス)が違うタイルだけclick (冪等・一方向) */
  function syncToDiag(keys){
    var tiles = document.querySelectorAll('#wzGames [data-gk]');
    tiles.forEach(function(t){
      var want = keys.indexOf(t.dataset.gk) >= 0;
      var has = t.classList.contains('on');
      if (want !== has) t.click();
    });
  }

  /* ステーション01のサマリー表示 */
  function updateCarry(labels){
    var station = scope.querySelector('.gs-station[data-station="title"]');
    if (!station) return;
    var summary = station.querySelector('.tgv3-carry-summary');
    if (labels.length === 0 || userExpandedTitles){
      station.classList.remove('tgv3-carry');
      if (summary) summary.remove();
      return;
    }
    station.classList.add('tgv3-carry');
    if (!summary){
      summary = document.createElement('div');
      summary.className = 'tgv3-carry-summary';
      summary.innerHTML = '<span class="tgv3-carry-summary__names"></span>'
        + '<button type="button" class="tgv3-carry-summary__edit">変更する</button>';
      var body = station.querySelector('.gs-station__body');
      if (body) body.insertBefore(summary, body.firstChild);
      summary.querySelector('.tgv3-carry-summary__edit').addEventListener('click', function(){
        userExpandedTitles = true;
        station.classList.remove('tgv3-carry');
        summary.remove();
      });
    }
    summary.querySelector('.tgv3-carry-summary__names').textContent = labels.join(' / ');
  }

  function updateLauncherPicked(labels){
    if (!pickedWrap || !pickedList) return;
    pickedWrap.hidden = labels.length === 0;
    pickedList.textContent = labels.join(' / ');
  }

  function openConsult(){
    if (isOpen) return;
    isOpen = true;
    var picked = getPicked();
    app.classList.remove('tgv3-hidden');
    launcher.classList.add('tgv3-hidden');
    openBtn.setAttribute('aria-expanded', 'true');
    syncToDiag(picked.keys);
    updateCarry(picked.labels);
    /* スクロール + フォーカス (a11y) */
    var heading = scope.querySelector('.gs-pit__intro-title');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var target = document.getElementById('tg-ai-diagnose');
    if (target){
      var y = window.scrollY + target.getBoundingClientRect().top - 70;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (heading){
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  }

  openBtn.addEventListener('click', openConsult);

  /* グリッドの選択変更を購読 (一方向: グリッド→診断) */
  document.addEventListener('tgv3:pickchange', function(e){
    var d = e.detail || { keys: [], labels: [] };
    if (isOpen){
      syncToDiag(d.keys);
      updateCarry(d.labels);
    } else {
      updateLauncherPicked(d.labels);
    }
  });

  /* 初期化: 既存JSのロード時初期化を妨げないよう、後からhidden付与。
     #tg-ai-diagnose ハッシュ着地時は畳まず自動で開く */
  function initState(){
    if (location.hash === '#tg-ai-diagnose'){
      openConsult();
    } else {
      app.classList.add('tgv3-hidden');
    }
    updateLauncherPicked(getPicked().labels);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      requestAnimationFrame(initState);
    });
  } else {
    requestAnimationFrame(initState);
  }
})();
